import { ReactElement } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Styles } from 'common/types/styles';
import { userService } from 'common/services/user.service';
import { theme } from 'common/constants/theme';
import { PDPAttributeHistoryV2Item } from 'common/services/api/content/content-api.types';
import { WalmartRetailers } from 'common/constants/entities';
import { PdpHistoryItem } from './pdp-history-item';

const styles: Styles = {
  tableContainer: { width: '100%', maxHeight: '500px' },
  descriptionContainer: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 },
  descriptionColumn: { width: 250 },
  noItems: { fontSize: 12, color: theme.palette.grey[700], margin: '0 auto', display: 'block', width: 'max-content' },
  cell: { minWidth: '150px', whiteSpace: 'nowrap' },
};

interface Props {
  history: Array<PDPAttributeHistoryV2Item> | null;
}

export function PdpHistoryContent({ history }: Props): ReactElement {
  const isL3 = userService.ensureLevel('L3');

  return (
    <TableContainer sx={styles.tableContainer}>
      {Boolean(history?.length) && (
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.cell}>Date</TableCell>
              <TableCell sx={styles.cell}>Model Name</TableCell>
              {!isL3 && <TableCell sx={styles.cell}>Cost</TableCell>}
              {userService.ensureRetailers(WalmartRetailers) ? (
                <>
                  <TableCell sx={styles.cell}>Generated Value</TableCell>
                  <TableCell sx={styles.cell}>Revised Value</TableCell>
                </>
              ) : (
                <>
                  <TableCell sx={styles.cell}>Process</TableCell>
                  <TableCell sx={styles.cell}>Title</TableCell>
                  <TableCell sx={styles.cell}>Description</TableCell>
                  <TableCell sx={styles.cell}>Features</TableCell>
                  <TableCell sx={styles.cell}>Keywords</TableCell>
                </>
              )}
              <TableCell sx={styles.cell}>Rationale</TableCell>
              <TableCell sx={styles.cell}>Request</TableCell>
              <TableCell sx={styles.cell}>Response</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history
              ?.sort((a, b) => new Date(b.generatedAt).getTime() - new Date(a.generatedAt).getTime())
              ?.map((item, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <PdpHistoryItem key={i} h={item} />
              ))}
          </TableBody>
        </Table>
      )}
      {!history?.length && <Typography sx={styles.noItems}>No history</Typography>}
    </TableContainer>
  );
}
